import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export const Hero = () => {
  return <section id="home" className="pt-28 pb-20 md:pt-36 md:pb-28 bg-gradient-to-br from-gray-50 to-white dark:from-gray-900 dark:to-gray-800 transition-colors" data-id="element-148">
      <div className="container mx-auto px-4 md:px-6" data-id="element-149">
        <div className="flex flex-col md:flex-row items-center" data-id="element-150">
          <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-151">
            <motion.h1 initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-152">
              <motion.span initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.2
            }} className="block text-gray-900 dark:text-white" data-id="element-153">
                Hi, I'm OTO
              </motion.span>
              <motion.span initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.4
            }} className="text-indigo-600 dark:text-indigo-400" data-id="element-154">
                Digital Product Designer
              </motion.span>
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} className="text-lg text-gray-600 dark:text-gray-300 mb-8 max-w-md" data-id="element-155">
              I create innovative mobile applications and digital experiences
              that connect users with job opportunities in real-time.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.8
          }} className="flex flex-col sm:flex-row gap-4" data-id="element-156">
              <motion.a href="#projects" whileHover={{
              scale: 1.05,
              boxShadow: '0 10px 30px rgba(79, 70, 229, 0.3)'
            }} whileTap={{
              scale: 0.95
            }} transition={{
              duration: 0.2
            }} className="inline-flex items-center justify-center px-6 py-3 bg-indigo-600 dark:bg-indigo-500 text-white font-medium rounded-md hover:bg-indigo-700 dark:hover:bg-indigo-600 transition-colors" data-id="element-157">
                View My Work <ArrowRight size={16} className="ml-2" data-id="element-158" />
              </motion.a>
              <motion.a href="#contact" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} transition={{
              duration: 0.2
            }} className="inline-flex items-center justify-center px-6 py-3 border border-indigo-600 dark:border-indigo-400 text-indigo-600 dark:text-indigo-400 font-medium rounded-md hover:bg-indigo-50 dark:hover:bg-gray-800 transition-colors" data-id="element-159">
                Contact Me
              </motion.a>
            </motion.div>
          </div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.4,
          ease: 'easeOut'
        }} className="md:w-1/2 md:pl-10" data-id="element-160">
            <div className="relative" data-id="element-161">
              <motion.div animate={{
              scale: [1, 1.1, 1],
              rotate: [0, 5, 0]
            }} transition={{
              duration: 8,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute -top-6 -left-6 w-24 h-24 bg-indigo-100 dark:bg-indigo-900/30 rounded-full z-0" data-id="element-162"></motion.div>
              <motion.div animate={{
              scale: [1, 1.15, 1],
              rotate: [0, -5, 0]
            }} transition={{
              duration: 10,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute -bottom-6 -right-6 w-32 h-32 bg-indigo-100 dark:bg-indigo-900/30 rounded-full z-0" data-id="element-163"></motion.div>
              <motion.img whileHover={{
              scale: 1.02
            }} transition={{
              duration: 0.3
            }} src="https://uploadthingy.s3.us-west-1.amazonaws.com/iYEw8EqdDCGvqTT44jVtKR/26_100.png" alt="Digital product design showcase" className="rounded-lg shadow-lg relative z-10 w-full h-auto object-cover" data-id="element-164" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};